// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__196VN","list":"styles_list__1SNjs"};